import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";

const Languages = ["en"];

const languageSelected = Languages[0];

declare module "i18next" {
  interface CustomTypeOptions {
    returnNull: false;
  }
}

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    lng: languageSelected,
    fallbackLng: languageSelected,
    supportedLngs: Languages,
    debug: false,
    returnNull: false,
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
